let bsParams = {
  /* 音像制品 出版情况登记表 */

  id: "", //
  publishMaterialId: "", //
  publishId: "", // 出版单位ID
  createdAt: "", //
  updatedAt: "", //

  firstYear: "", // [2017]年度
  firstTotalSales: "", // 出版单位[2017]年销售收入（万元）
  firstTotalProfit: "", // 出版单位[2017]年利润总额（万元）
  firstSales: "", // [2017]XX制品销售收入（万元）
  firstProfit: "", // [2017]XX制品利润总额（万元）
  firstPublicationVariety: "", // [2017]出版品种
  firstSalesVolumes: "", // [2017]销售数量（套/张）
  firstZtcbSales: "", // [2017]音像制品载体出版年销售收入（万元）
  firstZtcbProfit: "", // [2017]音像制品载体出版年利润总额（万元）
  firstWlcbSales: "", // [2017]音像制品信息网络出物年销售收入（万元）
  firstWlcbProfit: "", // [2017]音像制品信息网络出物年利润总额（万元）
  secondYear: "", // [2018]年度
  secondTotalSales: "", // 出版单位[2018]年销售收入（万元）
  secondTotalProfit: "", // 出版单位[2018]年利润总额（万元）
  secondSales: "", // [2018]XX制品销售收入（万元）
  secondProfit: "", // [2018]XX制品利润总额（万元）
  secondPublicationVariety: "", // [2018]出版品种
  secondSalesVolumes: "", // [2018]销售数量（套/张）
  secondZtcbSales: "", // [2018]音像制品载体出版年销售收入（万元）
  secondZtcbProfit: "", // [2018]音像制品载体出版年利润总额（万元）
  secondWlcbSales: "", // [2018]音像制品信息网络出物年销售收入（万元）
  secondWlcbProfit: "", // [2018]音像制品信息网络出物年利润总额（万元）
  firstSales1: "", //
  firstSales2: "", //
  firstSales3: "", //
  firstSales4: "", //
  firstSales5: "", //
  secondSales1: "", //
  secondSales2: "", //
  secondSales3: "", //
  secondSales4: "", //
  secondSales5: "", //
  firstPay: "", //
  firstPay1: "", //
  firstPay2: "", //
  firstPay3: "", //
  firstPay4: "", //
  firstPay5: "", //
  firstPay6: "", //
  firstPay7: "", //
  firstPay8: "", //
  secondPay: "", //
  secondPay1: "", //
  secondPay2: "", //
  secondPay3: "", //
  secondPay4: "", //
  secondPay5: "", //
  secondPay6: "", //
  secondPay7: "", //
  secondPay8: "", //
  firstTax: "", //
  secondTax: "", //
  firstFund: "", //
  secondFund: "", //
  firstSuperior: "", //
  secondSuperior: "", //
  firstZtcbVariety: "", //
  firstWlcbVariety: "", //
  secondZtcbVariety: "", //
  secondWlcbVariety: "", //
  firstZtcbDistributionChanne: "", //
  firstZtcbDistributionChanne1: "", //
  firstZtcbDistributionChanne2: "", //
  firstZtcbDistributionChanne3: "", //
  firstZtcbDistributionChanne4: "", //
  secondZtcbDistributionChanne: "", //
  secondZtcbDistributionChanne1: "", //
  secondZtcbDistributionChanne2: "", //
  secondZtcbDistributionChanne3: "", //
  secondZtcbDistributionChanne4: "", //
  firstWlcbDistributionChanne: "", //
  firstWlcbDistributionChanne1: "", //
  secondWlcbDistributionChanne: "", //
  secondWlcbDistributionChanne1: "", //
};

let paramsRule = {
  firstYear: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]年度
  firstTotalSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2017]年销售收入（万元）
  firstTotalProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2017]年利润总额（万元）
  firstSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]XX制品销售收入（万元）
  firstProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]XX制品利润总额（万元）
  firstPublicationVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]出版品种
  firstSalesVolumes: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]销售数量（套/张）
  firstZtcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品载体出版年销售收入（万元）
  firstZtcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品载体出版年利润总额（万元）
  firstWlcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品信息网络出物年销售收入（万元）
  firstWlcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品信息网络出物年利润总额（万元）
  secondYear: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]年度
  secondTotalSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2018]年销售收入（万元）
  secondTotalProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2018]年利润总额（万元）
  secondSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]XX制品销售收入（万元）
  secondProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]XX制品利润总额（万元）
  secondPublicationVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]出版品种
  secondSalesVolumes: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]销售数量（套/张）
  secondZtcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品载体出版年销售收入（万元）
  secondZtcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品载体出版年利润总额（万元）
  secondWlcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品信息网络出物年销售收入（万元）
  secondWlcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品信息网络出物年利润总额（万元）

  firstSales1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay6: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay7: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay8: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay6: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay7: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay8: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstTax: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondTax: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstFund: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondFund: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSuperior: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSuperior: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstWlcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondWlcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstWlcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstWlcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondWlcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondWlcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
};

export { bsParams, paramsRule };



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt3.js